// styles
import styles from "containers/SpecialApprovalRetrospectiveClaim/specialApprovalRetroClaim.module.css";

// ANT Components
import { Image } from "antd";
import type { UploadChangeParam, UploadFile } from "antd/es/upload/interface";

// atoms
import MultipleFileUpload from "components/atoms/FileUpload/MultipleFileUpload";
import Button from "components/atoms/Button/Button";
import Spinner from "components/atoms/Spinner/Spinner";
import StepInfo from "components/atoms/StepInfo/StepInfo";

// molecules
import { Head } from "components/molecules/Head/Head";
import RequestClaimDetails from "components/molecules/RequestClaimDetails/RequestClaimDetails";
import PageTitle from "components/molecules/PageTitle/PageTitle";

// hook
import { useSpecialApprovalRetroClaim, InputValueType } from "containers/SpecialApprovalRetrospectiveClaim/useSpecialApprovalRetroClaim";

// redux
import { RetroClaimType } from "redux/types";

// constants
import { PageTitles, SPECIAL_APPROVAL_RETRO_CLAIM as Constants } from "constants/global";

type SpecialApprovalProps = {
	retroClaimDetails: RetroClaimType;
	inputValue: InputValueType;
	loading: boolean;
	isReasonValid: boolean;
	validateReason: (v: string) => void;
	handleInput: (value: string) => void;
	goBack: () => void;
	handleFileInput: (info: UploadChangeParam<UploadFile>) => void;
	submitSpecialApproval: () => void;
};

const buttonTypeClass = (isActive: boolean, isReasonValid: boolean) => {
	if (isActive && isReasonValid) {
		return "activeLong";
	}
	return "disabledLong";
};

const SpecialApprovalRetrospectiveClaim = (): JSX.Element => {
	const componentProps: SpecialApprovalProps = useSpecialApprovalRetroClaim();
	const { validateReason, isReasonValid, retroClaimDetails, inputValue, handleInput, goBack, handleFileInput, submitSpecialApproval, loading } = componentProps;

	return (
		<div className={styles?.root}>
			{loading && <Spinner type="transparent" />}
			<Head>{PageTitles?.REVIEW_RETROSPECTIVE_CLAIM}</Head>
			<PageTitle showBackIcon={true} title={Constants.PAGE_TITLE} subTitle={Constants.PAGE_SUBTITLE} goBack={goBack} />
			<div className={styles?.main_wrapper}>
				<div className="md:flex">
					<div className={`${styles?.image_wrapper}`}>
						<Image src={retroClaimDetails.receipt_img_base64} preview={false} className={styles?.image} />
					</div>
					<div className={styles?.review_claim_form_wrapper}>
						<RequestClaimDetails
							isReasonValid={isReasonValid}
							validateReason={validateReason}
							retroClaimDetails={retroClaimDetails}
							inputValue={inputValue}
							handleInput={handleInput}
						/>
						<div className={`request_claim_file_upload multipleFileUpload`}>
							<MultipleFileUpload handleFileInput={handleFileInput} accept={Constants.SPECIAL_APPROVAL_FILETYPE} />
						</div>
					</div>
				</div>
				<div className={styles?.bottom_wrapper}>
					<div className={styles?.info_message}>
						<StepInfo message={Constants.MESSAGE} />
					</div>
					<div className={styles?.approval_button}>
						<Button type={buttonTypeClass(inputValue?.active, isReasonValid)} label={Constants.BUTTON_LABEL} onClick={submitSpecialApproval} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default SpecialApprovalRetrospectiveClaim;
